module.exports = __webpack_public_path__ + "static/media/pause_i.b7846851.svg";